

import React from "react";
import { LanguageProvider } from './LanguageContext';
import MapComponent from './component/MapComponent';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Nav from './ui/Nav';
import NewsBar from './ui/Newsbar'
import AdminOrder from "./Pages/adminOrder";
import { Route, Routes } from "react-router-dom";
// import { Signup } from "./component/Signup";
import Addnew from "./component/Addnew";
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { MdOutlineHomeWork } from "react-icons/md";
import { useTranslation } from "react-i18next";
import Myposts from "./Pages/Myposts/Myposts";
import Signin from "./Pages/Signin/Signin";
import Signup from "./Pages/Signup/Signup";
import Finished from "./component/Finished";
import Profile from "./Pages/Profile/profile";
import { UserImageProvider } from "./context/usecontextImage";
import Resubscribe from "./Pages/Resubscribe";
import Newcar from "./Pages/Newcar/Newcar";
import Newproject from "./Pages/Project/Newproject";
import Cars from "./Pages/Cars/Cars";
import { UserProvider } from "./context/usecontextUser";
import ProtectedRoute from "./Pages/adminOrder/protectRoute";
import Developer from "./Pages/adminOrder/Developer";
import Project from "./Pages/adminOrder/Project";
import Projectpage from "./Pages/Project/Projectpage";
import Developerpage from "./Pages/Developer";
import Projectofdeveloper from "./Pages/Projectofdeveloper";
import Managemant from "./Pages/adminOrder/Managemant";
function App() {
  const queryClient = new QueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();


  return (
    <LanguageProvider>
      <React.StrictMode >
        <UserProvider>
          <UserImageProvider>
            <Nav />
            <QueryClientProvider client={queryClient}>

              <Routes>
                <Route path="/" element={<MapComponent />} />
                <Route path="/cars" element={<Cars />} />
                <Route path="/Signup" element={<Signup />} />
                <Route path="/Signin" element={<Signin />} />
                <Route path="/Addnew" element={<Addnew />} />
                <Route path="/AddnewCar" element={<Newcar />} />
                <Route path="/Addnewproject" element={<Newproject />} />
                <Route path="/Myposts" element={<Myposts />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/projectofdeveloper/:id" element={<Projectofdeveloper />} />
                 <Route path="/management/projectofdeveloper/:id" element={<Projectofdeveloper />} />
                <Route path="/finished/:id" element={<Finished />} />
                <Route path="/Resubscribe" element={<Resubscribe />} />
                <Route path="/projectpage" element={<Projectpage />} />
                <Route path="/developerpage" element={<Developerpage />} />
                <Route element={<ProtectedRoute allowedRoles={[1]} />}>
                  <Route path="/admin" element={<AdminOrder />} />
                  <Route path="/developer" element={<Developer />} />
                  <Route path="/developer/:id" element={<Developer />} />
                  <Route path="/project/:id" element={<Project />} />
                  <Route path="/project" element={<Project />} />
                   <Route path="/management" element={<Managemant/> } />
                </Route>
              </Routes>

            </QueryClientProvider>
          </UserImageProvider>
        </UserProvider>
      </React.StrictMode>
    </LanguageProvider>
  )
}

export default App;
